<div class="container container--mobile-padding">
	<section class="main-work" [class.show]="mastHead">
		<ng-container *ngIf="mastHead">
			<tile-item [dataItem]="mastHead" [srcUrl]="'work'"></tile-item>
		</ng-container>
	</section>
	<grid-works *ngIf="homeItemArray && homeItemArray.length" [works]="homeItemArray" [srcUrl]="'work'" #gridWorks></grid-works>
</div>
